import { render } from "./basic_user_card.vue?vue&type=template&id=dd332bac"
import script from "./basic_user_card.js?vue&type=script&lang=js"
export * from "./basic_user_card.js?vue&type=script&lang=js"

import "./basic_user_card.vue?vue&type=style&index=0&id=dd332bac&lang=scss"

import exportComponent from "M:\\Viridian Patriots\\Server\\pleroma-fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__